module.exports = __webpack_public_path__ + "media/images/tomasz-2f17aa6c3045d81392883e45f7e404cb.jpg";